import store from '@/store';
import moment from 'moment';

export default {
  methods: {
    /**
     * Unselects a product and resets its details
     */
    unselectProduct() {
      store.commit('admin/setSelectedProduct', null);
      // auto tab switch
      store.commit(
        'admin/setCurrentProductTab',
        store.state.admin.PRODUCT_TABS.LIST
      );
      this.clearChildSelectionModels();
    },
    /**
     * Selects a product and fetches its details
     *
     * @param {*} product
     */
    selectProduct(product) {
      store.commit('admin/setSelectedProduct', product);
      store.dispatch('admin/getProductAttributeValueList', product.id);
      store.dispatch('admin/getProductAccessoryList', product.id);
      store.dispatch('admin/getProductRequirementList', product.id);
      store.dispatch('admin/getProductSettingList', product.id);
      store.dispatch('admin/getImageList', product.id);
      // auto tab switch
      store.commit(
        'admin/setCurrentProductTab',
        store.state.admin.PRODUCT_TABS.EDIT
      );

      this.clearChildSelectionModels();
    },
    /**
     * Clears child selection models
     */
    clearChildSelectionModels() {
      store.commit('admin/setSelectionModel', {
        entity: 'selectedProductAttributeValueSelectionModel',
        value: null
      });
      store.commit('admin/setSelectedProductAttributeValue', null);
      store.commit('admin/setProductAttributeValueList', []);

      store.commit('admin/setSelectionModel', {
        entity: 'selectedProductAccessorySelectionModel',
        value: null
      });
      store.commit('admin/setSelectedProductAccessory', null);
      store.commit('admin/setProductAccessoryList', []);

      store.commit('admin/setSelectionModel', {
        entity: 'selectedProductRequirementSelectionModel',
        value: null
      });
      store.commit('admin/setSelectedProductRequirement', null);
      store.commit('admin/setProductRequirementList', []);

      store.commit('admin/setSelectionModel', {
        entity: 'selectedProductSettingSelectionModel',
        value: null
      });
      store.commit('admin/setSelectedProductSetting', null);
      store.commit('admin/setProductSettingList', []);
    },
    /**
     * Returns a productType name for input id
     */
    getProductTypeName(id) {
      return this.admin.productTypeList.find((x) => x.id == id)?.name;
    },
    /**
     * Formats input date as MMMM DD YYYY
     * @param {*} date
     * @returns
     */
    formatDate(date) {
      return date ? moment(date).format('MMMM DD YYYY') : '';
    },
    /**
     * Formats a number to x,xxx.xx
     * @param {*} value
     */
    formatPrice(value) {
      let val = (value / 1).toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
